import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { BookingStatsRangeArgs } from '../api/types/bookingStats.types';

import {
  fetchBookingStatsAttendance,
  fetchBookingStatsRevenue,
} from '../api/bookingStats.api';

/**
 * The key is `[args]` and nothing else. The finance stats keys append
 * `viewerTimeZone()` because the server buckets THEIR calendar series in the
 * zone the request names; this endpoint buckets in the EVENT's own stored zone,
 * which no request parameter can move. Adding the viewer's zone here would
 * fragment the cache into identical responses and refetch the whole screen for
 * a traveller who changed nothing.
 */
export const bookingStatsQueryKeys = createQueryKeys('bookingStats', {
  fetchAttendance: (args: BookingStatsRangeArgs) => ({
    queryFn: () => fetchBookingStatsAttendance(args),
    queryKey: [args],
  }),
  fetchRevenue: (args: BookingStatsRangeArgs) => ({
    queryFn: () => fetchBookingStatsRevenue(args),
    queryKey: [args],
  }),
});
